import { useTranslation } from 'react-i18next';
import { Trophy } from 'lucide-react';

import { useGetLeaderboardQuery } from '@/services/qchinesepokerApi';
import { useQcpMe } from '@/hooks/useQcpMe';
import { QcpRestNotice } from '@/components/chinesepoker/QcpRestNotice';
import { Loader } from '@/components/common/Loader';
import { cn } from '@/lib/cn';

/** Hub "Classifica" section for Chinese Poker: ELO top 50, own row highlighted. */
export function QcpLeaderboardPanel() {
  const { t } = useTranslation('chinesepoker');
  const { data, isLoading, isError, error, refetch } = useGetLeaderboardQuery({ limit: 50 });
  // `null` = il BFF ha risposto con una forma che non e' una classifica: errore, non «nessun giocatore».
  const mioUserId = useQcpMe();
  const failed = isError || data === null;
  const players = data ?? [];

  return (
    <div className="flex min-h-0 flex-1 flex-col gap-2 overflow-y-auto py-2">
      {isLoading && (
        <div className="flex h-32 items-center justify-center">
          <Loader />
        </div>
      )}
      {!isLoading && failed && <QcpRestNotice error={error} fallback={t('home.lbError')} onRetry={() => void refetch()} />}
      {!isLoading && !failed && players.length === 0 && (
        <p className="rounded-xl bg-bg-secondary p-4 text-center text-sm text-fg-muted">
          {t('hubPanels.lbEmpty', { defaultValue: 'No ranked matches yet.' })}
        </p>
      )}
      {players.length > 0 && (
        <ul className="divide-y divide-border overflow-hidden rounded-xl border border-border bg-bg-secondary">
          {players.map((p) => {
            const me = mioUserId !== null && p.userId === mioUserId;
            return (
              <li
                key={p.userId}
                className={cn('flex items-center gap-3 px-4 py-2.5', me && 'bg-brand/15')}
              >
                <span className="w-7 text-sm tabular-nums text-fg-muted">{p.rank}</span>
                <span className={cn('flex-1 truncate text-sm', me ? 'font-semibold text-brand' : 'text-fg')}>
                  {p.displayName}
                </span>
                {me && <Trophy aria-hidden className="h-3.5 w-3.5 text-brand" />}
                <span className="text-sm font-semibold tabular-nums text-brand">{p.elo}</span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
